import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-salesforce-tag',
    templateUrl: './salesforce-tag.component.html',
    standalone: true
})
export class SalesforceTagComponent {
  @Input() svgTitle: string = "";
}
